import { savedTokens } from 'src/auth'
import { ErrorApi, ErrorNotLoggedIn, Preloader } from 'src/components'
import ChartUsers from '../Chart'
import { useGetChartOrganizations } from '../Chart/queries'

type Props = {
  organization: string
  username: string
}

function OnlineUsersChart(props: Props) {
  const { data, status, error, refetch } = useGetChartOrganizations({
    organization: props.organization,
    username: props.username,
  })

  if (status === 'loading' || status === 'idle') {
    return <Preloader />
  }

  if (status === 'error') {
    return <ErrorApi message={error} onClick={refetch} />
  }

  if (!data?.length) {
    return <div>Empty</div>
  }

  return <ChartUsers items={data} />
}

export default function ValidateOnlineUsersChart() {
  const [tokens] = savedTokens.useState(null)

  if (!tokens) {
    return <ErrorNotLoggedIn />
  }
  return (
    <OnlineUsersChart
      organization={tokens.organization}
      username={tokens.username}
    />
  )
}
